import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    createChannel = new Subject();
    checkDateChannel = new Subject();
    getMaxDateChannel = new Subject();
    employeeChannel = new Subject();
    checkNumberChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.checkDateChannel.next({status: apiResponse.INITIAL})
        this.getMaxDateChannel.next({status: apiResponse.INITIAL})
        this.employeeChannel.next({status: apiResponse.INITIAL})
        this.checkNumberChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchCheckDate = async (query) => {
        try {
            this.checkDateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCheckDate(query).then((result) => {
                this.checkDateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.checkDateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchMaxDate = async (query) => {
        this.getMaxDateChannel.next({status: apiResponse.LOADING})
        try {
             await this.repository.fetchMaxDate(query).then((result) => {
                this.getMaxDateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.getMaxDateChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }

    fetchEmployee = async (query) => {
        try {
            this.employeeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEmployee(query).then((result) => {
                this.employeeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.employeeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchCheckNumber = async (query) => {
        try {
            this.checkNumberChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCheckNumber(query).then((result) => {
                this.checkNumberChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.checkNumberChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }
}

export default CreateBloc